import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

const HomePage: React.FC = () => {
    const location = useLocation();

    return <Navigate to={`/profile${location.search}${location.hash}`} replace />;
};

export default HomePage;
